<template>
  <div>
    <EditableArea
      v-if="column"
      :class="{ 'mx-auto my-xl flex flex-wrap justify-between': column?.nodes?.length }"
      :content="column"
      :style="{ flexDirection }"
      :data-ab-id="dataAbId"
    />
  </div>
</template>

<script lang="ts" setup>
// @ts-expect-error missing declaration file with types
import { EditableArea } from '@magnolia/vue-editor/dist/vue-editor.es.js';

interface Props {
  column?: any;
  flexibleLayout?: string;
  dataAbId?: string;
}

const props = withDefaults(defineProps<Props>(), {
  column: undefined,
  flexibleLayout: 'raw',
});

const flexDirection = `${props.flexibleLayout}`;
</script>
